import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "ss_cookie_notice";

export const CookieBanner = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try { setOpen(!localStorage.getItem(KEY)); } catch { setOpen(false); }
  }, []);

  const close = () => {
    try { localStorage.setItem(KEY, new Date().toISOString()); } catch { /* storage non disponibile */ }
    setOpen(false);
  };

  if (!open) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-[90] p-3 sm:p-5 animate-in slide-in-from-bottom duration-700" data-testid="cookie-banner">
      <div className="max-w-5xl mx-auto bg-seta border border-line border-t-2 border-t-oro shadow-[0_22px_60px_rgba(30,28,26,0.12)] p-6 sm:p-8 flex flex-col sm:flex-row sm:items-center gap-7">
        <Cookie size={22} strokeWidth={1.3} className="text-oro shrink-0 hidden sm:block" />
        <div className="flex-1">
          <p className="eyebrow !text-[10px] mb-2">Cookie</p>
          <p className="text-[13.5px] text-stoneish leading-[1.7]">
            Usiamo <b className="text-ink font-medium">solo cookie tecnici</b> necessari a far funzionare il sito: l'accesso all'area clienti, l'accesso al gestionale e la protezione anti-spam dei moduli.
            Nessuna profilazione, nessuna pubblicità, nessuna statistica di terze parti: per questi strumenti la normativa non richiede il vostro consenso.{" "}
            <Link to="/cookie-policy" className="link-u text-ink" data-testid="cookie-banner-policy-link">Cookie Policy</Link>
            {" · "}
            <Link to="/privacy-policy" className="link-u text-ink" data-testid="cookie-banner-privacy-link">Privacy Policy</Link>
          </p>
        </div>
        <button onClick={close} data-testid="cookie-banner-accept" className="btn-ink shrink-0 justify-center">Ho capito</button>
      </div>
    </div>
  );
};
